<div class="form-container">
  <!-- <h1 class="ion-text-center ion-margin-bottom">
    {{ role ? "Registrate" : " Registra tus facturas" }}
  </h1> -->
  <h1 class="ion-text-center ion-margin-bottom">
    {{
      isUpdateDataMode
        ? 'Actualiza tus datos'
        : (pqrsMode
            ? 'Registra tu PQR'
            : (role
                ? 'Registrate'
                : 'Registra tus facturas'))
    }}
  </h1>
  <div class="ion-margin-top ion-padding-top">
    <app-form [questions]="loginQuestions" (submit)="continue()" (documentChanged)="validateDocument()"></app-form>

    <!-- <ion-item lines="none" *ngIf="contest?.terms_and_conditions">
      <ion-checkbox
        labelPlacement="end"
        aria-labelledby="terms-lbl"
        [(ngModel)]="termsAccepted"
      ></ion-checkbox>
      <ion-label class="ion-padding-start ion-text-wrap" id="terms-lbl">
        Acepto los
        <a [href]="contest?.terms_and_conditions" target="_blank"
          >Términos y Condiciones de la actividad.</a
        >
      </ion-label>
    </ion-item> -->

    <ion-item lines="none" *ngIf="configService.mall?.customer?.privacy_policy">
      <ion-checkbox labelPlacement="end" aria-labelledby="priv-lbl" [(ngModel)]="privacyPolicyAccepted"></ion-checkbox>
      <ion-label class="ion-padding-start ion-text-wrap" id="priv-lbl">
        {{ configService.mall?.customer?.privacy_policy_text || 'Acepto el tratamiento de mis datos personales de acuerdo con la autorización' }}
        <a [href]="configService.mall?.customer?.privacy_policy" target="_blank">
          disponible aquí.
        </a>
      </ion-label>
    </ion-item>
  </div>

  <ion-grid>

  <ion-row *ngIf="!loading && !pqrsMode">
    <ion-col size="8" sizeMd="6" style="margin: auto" *ngIf="!role">
      <ion-button
        expand="block"
        color="secondary"
        class="ion-text-wrap"
        (click)="goShowBills()">
        Ver facturas registradas
      </ion-button>
    </ion-col>

    <ion-col size="8" sizeMd="6" style="margin: auto">
      <ion-button
        expand="block"
        class="ion-text-wrap"
        [disabled]="!privacyPolicyAccepted || !isDocumentValid"
        (click)="continue()"
      >
        Siguiente
      </ion-button>
    </ion-col>

    <ion-col size="8" sizeMd="6" style="margin: auto" *ngIf="showBack">
      <ion-button
        expand="block"
        class="ion-text-wrap"
        fill="clear"
        (click)="goBack()"
      >
        Volver
      </ion-button>
    </ion-col>
  </ion-row>

  <!-- just for pqrs mode -->
  <ion-row *ngIf="!loading && pqrsMode" class="ion-justify-content-center ion-text-center">
    <ion-col size="8" sizeMd="6" style="margin: auto">
      <ion-button
        expand="block"
        class="ion-text-wrap"
        [disabled]="!privacyPolicyAccepted || !isDocumentValid"
        (click)="continue()"
      >
        Crea tu PQR
      </ion-button>
    </ion-col>
  </ion-row>

    <ion-row *ngIf="loading">
      <ion-col size="8" sizeMd="6" class="ion-text-center" style="margin: auto">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
